import { isValid } from './isValid';
import { TFormValues } from '../../../types/requestDemand';
import { ERequestDemandField } from '../../../constants/requestDemand';

export const getFormErrors = (formValue: TFormValues): TFormValues | null => {
  let fieldsWithError = {} as TFormValues;
  const isFormValid = [ERequestDemandField.EMAIL, ERequestDemandField.PHONE].reduce((_isFormValid, name) => {
    const isFieldValid = isValid(name, formValue[name].value);
    if (!isFieldValid) {
      fieldsWithError = {
        ...fieldsWithError,
        [name]: {
          isError: true,
          value: formValue[name].value,
        },
      };
    }

    return _isFormValid && isFieldValid;
  }, true);

  return isFormValid ? null : fieldsWithError;
};
